import { Code, Divider } from '@apollo/orbit';
import React from 'react';

import { ErrorInsightsListGroupByColumn } from 'src/lib/graphqlTypes/types';

import { ErrorGroupName } from './ErrorGroupTitle';
import { CodeInfoIcon, ServiceIcon } from './GroupIcon';
import { GroupOption } from './sharedTypes';

export function DrilldownContext({
  groupByDimension,
  groupByDimensionValue,
  breakdownByDimensionValue,
}: {
  groupByDimension: GroupOption;
  groupByDimensionValue: string;
  breakdownByDimensionValue: string;
}) {
  return (
    <div className="inline-flex items-center gap-2 rounded border border-info/20 bg-info p-2">
      <ErrorGroupName
        icon={
          groupByDimension === ErrorInsightsListGroupByColumn.SERVICE ? (
            <ServiceIcon serviceName={groupByDimensionValue} />
          ) : undefined
        }
        rightIcon={
          groupByDimension === ErrorInsightsListGroupByColumn.CODE ? (
            <CodeInfoIcon code={groupByDimensionValue} />
          ) : undefined
        }
      >
        {groupByDimensionValue}
      </ErrorGroupName>
      <Divider className="mx-1 h-6 border-info/30" orientation="vertical" />
      <Code className="bg-primary">{breakdownByDimensionValue}</Code>
    </div>
  );
}
